import TipView from '../../Tipping/Tip';
import template from './index.jst';
import './index.styl';
import _ from 'lodash';

export class StreakTipView extends TipView {
	get template() {
		return template;
	}

	onMakeBet({ target }) {
		const
			predict_winner_squad_id = parseInt(target.value, 10),
			predict_margin = this.model.get('predict_margin') || 0,
			if_need_remove_tip = $(target).hasClass('remove-tip');

		if(if_need_remove_tip) {
			const round_id = $(target).data('round');
			this.trigger('make:remove:squad', {
				predict_winner_squad_id,
				predict_margin,
				round_id,
			});
		}
		else {
			this.model.set({ predict_winner_squad_id });
			this.trigger('make:bet', { predict_winner_squad_id, predict_margin });
		}
	}

	updateMargin(predict_margin) {
		if(_.isFunction(this.ui)){
			return this;
		}

		const predict_winner_squad_id = this.model.get('predict_winner_squad_id');

		this.ui.input_margin.val(predict_margin);

		this.model.set({ predict_margin });

		this.trigger('make:bet', { predict_margin, predict_winner_squad_id });

		return this;
	}

	_getSelectedClassName(predict_winner_squad_id, home_squad_id) {
		const
			is_selected = predict_winner_squad_id !== 0,
			is_selected_left = home_squad_id === predict_winner_squad_id;

		if (is_selected) {
			return `tip-selected-${ is_selected_left ? 'left' : 'right' }`;
		}

		return '';
	}

	_getSideResultClassName(is_match_end, is_correct, side){
		if (is_match_end) {
			const correct_class_name = is_correct ? 'correct' : 'incorrect';
			return `tip-selected-${side}-${correct_class_name}`;
		}

		return '';
	}

	_getDisabledClassName(is_disabled){
		return is_disabled ? 'tip-with-score' : '';
	}

	updateViewClassNameField() {
		const {
			is_home_match_end,
			is_home_select_correct,
			is_away_match_end,
			is_away_select_correct,
			is_disabled,
			predict_winner_squad_id,
			home_squad_id,
		} = this.model.attributes;

		this.className = [
			this._getSelectedClassName(predict_winner_squad_id, home_squad_id),
			this._getSideResultClassName(is_home_match_end, is_home_select_correct, 'left'),
			this._getSideResultClassName(is_away_match_end, is_away_select_correct, 'right'),
			this._getDisabledClassName(is_disabled)
		].join(' ');

		return this;
	}

	validateMarginValue({ target }) {
		let value = target.value.trim();
		const is_valid = target.checkValidity() && value !== '';

		if (!is_valid) {
			value = '0';
		}

		target.value = value;

		const
			is_changed = value !== String(this.model.get('predict_margin'));

		if (!is_changed) {
			return;
		}

		const
			predict_margin = parseInt(value, 10),
			predict_winner_squad_id = this.model.get('predict_winner_squad_id');

		this.model.set({ predict_margin });

		this.trigger('make:bet', { predict_margin, predict_winner_squad_id });
	}
}

export default StreakTipView;